import React, { Component } from 'react';

export default class Answer extends Component {
    handleClick = () => {
        this.props.onAnswerClick(this.props.answer);
    };

    render() {
        const {
            identifier,
            indexLetter,
            answer: { text }
        } = this.props;
        const className = "answerListItem answer-" + identifier;
        return (
            <li className={className} onClick={this.handleClick}>
                <div className="answerInfo">
                    <div className="index">{indexLetter}</div>
                    <div className="text" dangerouslySetInnerHTML={{__html: text}} />
                </div>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Answer.js